"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradients = exports.palette = void 0;
exports.palette = {
    'gray1': '#12141D',
    'gray2': '#191B25',
    'gray3': '#1E2029',
    'gray4': '#272935',
    'gray5': '#343746',
    'gray6': '#3E4255',
    'gray7': '#494E64',
    'gray8': '#868CA6',
    'gray9': '#B2B6C7',
    'gray10': '#FFFFFF',
    'yellow1': '#4a3a00',
    'yellow2': '#735a00',
    'yellow3': '#9c7900',
    'yellow4': '#c49900',
    'yellow5': '#edb900',
    'yellow6': '#ffcc17',
    'yellow7': '#ffd540',
    'yellow8': '#ffde69',
    'yellow9': '#ffe791',
    'yellow10': '#fff0ba',
    'orange1': '#631800',
    'orange2': '#B02A00',
    'orange3': '#D43300',
    'orange4': '#FF3F02',
    'orange5': '#FF5E2B',
    'orange6': '#FF7D54',
    'orange7': '#FF906E',
    'orange8': '#FFA487',
    'orange9': '#FFBFAB',
    'orange10': '#FFD2C4',
    'red1': '#5F0900',
    'red2': '#920F00',
    'red3': '#C51400',
    'red4': '#FA1900',
    'red5': '#FF412C',
    'red6': '#FF5555',
    'red7': '#FF6F6F',
    'red8': '#FF8888',
    'red9': '#FFA2A2',
    'red10': '#FFBBBB',
    'pink1': '#3D0A3D',
    'pink2': '#691169',
    'pink3': '#951895',
    'pink4': '#C020C0',
    'pink5': '#DE35DE',
    'pink6': '#E561E5',
    'pink7': '#E97BE9',
    'pink8': '#EE96EE',
    'pink9': '#F2B0F2',
    'pink10': '#F6CAF6',
    'lightPurple1': '#29004F',
    'lightPurple2': '#3F0078',
    'lightPurple3': '#5400A1',
    'lightPurple4': '#6A00C9',
    'lightPurple5': '#7F00F2',
    'lightPurple6': '#931CFF',
    'lightPurple7': '#A645FF',
    'lightPurple8': '#BA6EFF',
    'lightPurple9': '#CD96FF',
    'lightPurple10': '#E1BFFF',
    'purple1': '#1A1325',
    'purple2': '#24163A',
    'purple3': '#301C4D',
    'purple4': '#3E2069',
    'purple5': '#51258F',
    'purple6': '#642AB5',
    'purple7': '#854ECA',
    'purple8': '#AB7AE0',
    'purple9': '#CDA8F0',
    'purple10': '#EBD7FA',
    'blue1': '#000B2C',
    'blue2': '#021140',
    'blue3': '#01228C',
    'blue4': '#012EBF',
    'blue5': '#013BF2',
    'blue6': '#285BFE',
    'blue7': '#416EFE',
    'blue8': '#5B82FE',
    'blue9': '#7495FE',
    'blue10': '#8EA8FE',
    'lightBlue1': '#00232D',
    'lightBlue2': '#004256',
    'lightBlue3': '#00627F',
    'lightBlue4': '#0081A7',
    'lightBlue5': '#00A1D0',
    'lightBlue6': '#00C0F9',
    'lightBlue7': '#23CDFF',
    'lightBlue8': '#4CD6FF',
    'lightBlue9': '#74DFFF',
    'lightBlue10': '#9DE9FF',
    'turquoise1': '#004B4C',
    'turquoise2': '#007375',
    'turquoise3': '#019094',
    'turquoise4': '#01AEB2',
    'turquoise5': '#01CCD1',
    'turquoise6': '#01EAEF',
    'turquoise7': '#25FAFE',
    'turquoise8': '#58FBFE',
    'turquoise9': '#8AFCFF',
    'turquoise10': '#BDFDFF',
    'teal1': '#032F2D',
    'teal2': '#054C48',
    'teal3': '#06645E',
    'teal4': '#087C75',
    'teal5': '#09948B',
    'teal6': '#0BACA2',
    'teal7': '#0EDCCF',
    'teal8': '#2CF1E5',
    'teal9': '#5BF5EB',
    'teal10': '#8BF8F1',
    'green1': '#052B1B',
    'green2': '#085032',
    'green3': '#0C754A',
    'green4': '#109A61',
    'green5': '#14BF78',
    'green6': '#18E48F',
    'green7': '#3AEAA1',
    'green8': '#5FEEB3',
    'green9': '#84F2C4',
    'green10': '#A9F6D6',
    'brightGreen1': '#0C460A',
    'brightGreen2': '#147310',
    'brightGreen3': '#1CA016',
    'brightGreen4': '#24CD1C',
    'brightGreen5': '#40E438',
    'brightGreen6': '#6BEA65',
    'brightGreen7': '#81ED7B',
    'brightGreen8': '#96F092',
    'brightGreen9': '#ACF3A8',
    'brightGreen10': '#C1F6BF',
};
exports.gradients = {
    'yellowGradient': "linear-gradient(90deg, " + exports.palette.yellow6 + " 0%, " + exports.palette.orange6 + " 100%)",
    'orangeGradient': "linear-gradient(90deg, " + exports.palette.orange6 + " 0%, " + exports.palette.red6 + " 100%)",
    'redGradient': "linear-gradient(90deg, " + exports.palette.red6 + " 0%, " + exports.palette.pink6 + " 100%)",
    'pinkGradient': "linear-gradient(90deg, " + exports.palette.pink6 + " 0%, " + exports.palette.lightPurple6 + " 100%)",
    'lightPurpleGradient': "linear-gradient(90deg, " + exports.palette.lightPurple6 + " 0%, " + exports.palette.purple6 + " 100%)",
    'purpleGradient': "linear-gradient(90deg, " + exports.palette.purple6 + " 0%, " + exports.palette.blue6 + " 100%)",
    'blueGradient': "linear-gradient(90deg, " + exports.palette.blue6 + " 0%, " + exports.palette.lightBlue6 + " 100%)",
    'lightBlueGradient': "linear-gradient(90deg, " + exports.palette.lightBlue6 + " 0%, " + exports.palette.turquoise6 + " 100%)",
    'turquoiseGradient': "linear-gradient(90deg, " + exports.palette.turquoise6 + " 0%, " + exports.palette.green6 + " 100%)",
    'greenGradient': "linear-gradient(90deg, " + exports.palette.green6 + " 0%, " + exports.palette.brightGreen6 + " 100%)",
    'brightGreenGradient': "linear-gradient(90deg, " + exports.palette.brightGreen6 + " 0%, " + exports.palette.teal6 + " 100%)"
};
//# sourceMappingURL=palette.js.map